const selectors = {
  sectionContainer: "review-widget",
};

document.addEventListener("product:variant-change", function (event) {
  const variant = event.detail.variant;
  if (!variant) return;
  replaceReviewWidget();

  function replaceReviewWidget() {
    const reviewWidget = document.getElementById(selectors.sectionContainer);
    if (!reviewWidget) return;

    fetch(
      window.location.pathname + `?section_id=product-variant-review-widget&variant=${variant.id}`
    )
      .then((markup) => markup.text())
      .then((html) => {
        if (html && html.length) {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(html, "text/html");
          const newSection = htmlDoc.getElementById(selectors.sectionContainer);
          if (newSection) {
            reviewWidget.innerHTML = newSection.innerHTML;
          } else {
            reviewWidget.innerHTML = "";
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching variant reviews:", error);
      });
  }
});
